module.exports = __webpack_public_path__ + "static/img/free_ship.c4582ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/free_ship.png
// module id = 79SI
// module chunks = 1